import { fetchFactory } from '../../../utils/fetchFactory'

export const updateQrCodeEquipment = (body: { qrCode: string, newQrCode: string }) => fetchFactory('/api/admin/equipment/update', {
	method: 'POST',
	body: JSON.stringify(body)
})